import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import { QRCodeSVG } from "qrcode.react";
import axios from "axios";
import { socket } from "../Commponents/socket";

export default function Deposit() {
  const { copyaddress, profile ,formatAddress} = useContext(OnmaxContext);

  const [data, setData] = useState({});
  const [isPending, setIsPending] = useState(false);
  const [txMessage, setTxMessage] = useState(null);
  const [socketStatus, setSocketStatus] = useState("Disconnected"); // eslint-disable-line no-unused-vars
  const [countdown, setCountdown] = useState(30); // eslint-disable-line no-unused-vars

  const username = localStorage.getItem("username");

  // ===============================
  // FETCH USER DATA
  // ===============================
  useEffect(() => {
    if (!username) return;

    const getData = async () => {
      try {
        const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
          method: "user",
          submethod: "getbyid",
          username,
          key: process.env.REACT_APP_KEY,
        });
        if (!res.data.error) setData(res.data.data);
      } catch (err) {
        console.error("GetData Error:", err);
      }
    };

    getData();
  }, [username]);

  // ===============================
  // SOCKET HANDLING (SAFE)
  // ===============================
  useEffect(() => {
    if (!data?.address) return;

    if (!socket.connected) socket.connect();

    const userAddress = data.address.toLowerCase();

    const emitStartTransaction = () => {
      socket.emit("startTransaction", {
        socketId: socket.id,
        address: userAddress,
      });
      // console.log("startTransaction emitted:", userAddress, socket.id);
    };

    const onConnect = () => {
      setSocketStatus("Connected");
      emitStartTransaction();
    };

    const onPending = (tx) => {
      // console.log("PENDING EVENT:", tx);
      if (tx.to?.toLowerCase() !== userAddress) return;
      setIsPending(true);
      setTxMessage(null);
    };

    const onSuccess = (tx) => {
      // console.log("SUCCESS EVENT:", tx);
      if (tx.to?.toLowerCase() !== userAddress) return;
      setIsPending(false);
      setTxMessage(tx);
    };

    const onDisconnect = () => {
      console.log("Socket disconnected");
      setSocketStatus("Disconnected");
    };

    const onConnectError = (err) => {
      console.error("Socket connect error:", err.message);
    };

    socket.on("connect", onConnect);
    socket.on("connect_error", onConnectError);
    socket.on("pendingTransaction", onPending);
    socket.on("newTransaction", onSuccess);
    socket.on("disconnect", onDisconnect);

    if (socket.connected) {
      emitStartTransaction();
    }

    return () => {
      socket.off("connect", onConnect);
      socket.off("connect_error", onConnectError);
      socket.off("pendingTransaction", onPending);
      socket.off("newTransaction", onSuccess);
      socket.off("disconnect", onDisconnect);
    };
  }, [data?.address]);

  // ===============================
  // COUNTDOWN TIMER (FIXED)
  // ===============================
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => (prev <= 0 ? 30 : prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const customStyles = `
    /* QR Code Frame */
    .ai-qr-frame {
      background: #fff;
      padding: 15px;
      border-radius: 16px;
      display: inline-block;
      box-shadow: 0 0 20px rgba(16, 185, 129, 0.2);
      border: 4px solid #1e293b;
      position: relative;
    }
    
    .ai-qr-frame::after {
       content: '';
       position: absolute;
       inset: -8px;
       border-radius: 20px;
       border: 2px dashed #334155;
       z-index: -1;
    }

    /* Address Box */
    .ai-address-box {
      background: rgba(238, 242, 246, 0.5);
      border-radius: 16px;
      padding: 16px;
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 24px;
      transition: all 0.3s;
    }
    .ai-address-box:hover {
       border-color: #10b981;
    }
    
    .ai-wallet-icon {
       width: 40px; height: 40px;
       background: rgba(16, 185, 129, 0.1);
       color: #10b981;
       border-radius: 50%;
       display: flex; align-items: center; justify-content: center;
       margin-right: 12px;
       font-size: 18px;
    }
    
    .ai-address-text {
       flex: 1;
       word-break: break-all;
       font-family: 'Monaco', 'Consolas', monospace;
       color: #1e293b;
       font-size: 14px;
       font-weight: 700;
       line-height: 1.4;
    }
    
    .ai-copy-btn {
       background: #10b981;
       color: #fff;
       border: none;
       width: 36px; height: 36px;
       border-radius: 8px;
       display: flex; align-items: center; justify-content: center;
       cursor: pointer;
       transition: 0.2s;
       margin-left: 10px;
       box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    }
    .ai-copy-btn:hover {
       transform: translateY(-2px);
       box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4);
    }

    .ai-warning-box {
       background: rgba(245, 158, 11, 0.1);
       border: 1px solid rgba(245, 158, 11, 0.2);
       color: #d97706;
       border-radius: 12px;
       padding: 12px 16px;
       font-size: 13px;
       margin-top: 24px;
       display: flex; align-items: flex-start;
       font-weight: 600;
    }

  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />

        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-8 col-12">

                <div className="db-profile-card mb-5" style={{ position: 'relative' }}>

                  <div className="db-sec-hdr">
                    <div className="db-sec-dot"></div>
                    <div className="db-sec-title">Deposit Funds</div>
                  </div>
                  <div className="text-center mb-4 mt-3">
                    <span style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#d97706', padding: '8px 20px', borderRadius: '100px', fontSize: '14px', border: '1px solid rgba(245, 158, 11, 0.2)', fontWeight: '800', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                      Wallet Balance: ${profile?.totaldeposit ? Number(profile.totaldeposit).toFixed(2) : "0.00"}
                    </span>
                  </div>

                  <div className="p-0 d-flex flex-column align-items-center">


                    <div className="row justify-content-center w-100">
                      <div className="col-12">

                        <style>{`
                           .ai-loader-container {
                               padding: 40px; text-align: center;
                           }
                           .ai-radar-spinner {
                               width: 60px; height: 60px; border-radius: 50%;
                               border: 2px solid rgba(0, 111, 227, 0.3);
                               border-top-color: #006fe3;
                               margin: 0 auto 20px;
                               animation: spin 1s infinite linear;
                           }
                           @keyframes spin { 100% { transform: rotate(360deg); } }
                           
                           .ai-success-card {
                               background: rgba(16, 185, 129, 0.1);
                               border: 1px solid rgba(16, 185, 129, 0.3);
                               border-radius: 16px;
                               padding: 30px;
                               text-align: center;
                           }
                           .ai-success-icon {
                               width: 80px; height: 80px;
                               background: #10b981;
                               color: #fff;
                               border-radius: 50%;
                               font-size: 40px;
                               display: flex; align-items: center; justify-content: center;
                               margin: 0 auto 20px;
                               box-shadow: 0 0 30px rgba(16, 185, 129, 0.5);
                           }
                           .ai-tx-detail-row {
                               display: flex; justify-content: space-between;
                               padding: 12px 0;
                               border-bottom: 1px solid rgba(0,0,0,0.05);
                               font-size: 14px;
                           }
                           .ai-tx-label { color: #64748b; font-weight: 600; }
                           .ai-tx-val { color: #1e293b; font-family: monospace; }
                        `}</style>

                        {/* 🔄 SHOW PROGRESS BAR (AI SCANNER) */}
                        {isPending && (
                          <div className="ai-loader-container">
                            <div className="ai-radar-spinner"></div>
                            <h5 className="text-dark fw-bold mb-2">Scanning Blockchain...</h5>
                            <p className="text-secondary small">Waiting for confirmation (Est. 30s)</p>
                            <div className="progress mt-3" style={{ height: 4, background: '#e2e8f0' }}>
                              <div className="progress-bar bg-primary progress-bar-striped progress-bar-animated" style={{ width: '100%' }}></div>
                            </div>
                          </div>
                        )}

                        {/* ✅ SHOW TRANSACTION MESSAGE (AI SUCCESS) */}
                        {!isPending && txMessage && (
                          <div className="ai-success-card">
                            <div className="ai-success-icon">
                              <i className="fa fa-check"></i>
                            </div>
                            <h3 className="text-dark fw-bold mb-1">Payment Received!</h3>
                            <p className="text-success mb-4 fw-bold">Transaction Confirmed Successfully</p>

                            <div className="p-3 rounded-3" style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                              <div className="ai-tx-detail-row">
                                <span className="ai-tx-label">Amount</span>
                                <span className="ai-tx-val fw-bold text-success fs-5">{txMessage.amount} USDT</span>
                              </div>
                              <div className="ai-tx-detail-row">
                                <span className="ai-tx-label">Hash</span>
                                <a
                                  href={`https://bscscan.com/tx/${txMessage.hash}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="ai-tx-val text-truncate"
                                  style={{ maxWidth: 150, color: '#006fe3', cursor: 'pointer' }}
                                  title="View on BSCScan"
                                >
                                  {formatAddress(txMessage.hash)}
                                </a>
                              </div>
                              <div className="ai-tx-detail-row border-0">
                                <span className="ai-tx-label">Status</span>
                                <span className="badge bg-success bg-opacity-25 text-success p-2">COMPLETED</span>
                              </div>
                            </div>

                            <button className="db-btn w-100 mt-4 py-3" onClick={() => window.location.reload()} style={{ background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', border: 'none', borderRadius: '16px', fontWeight: '800', boxShadow: '0 10px 20px rgba(16, 185, 129, 0.3)' }}>
                              Make Another Deposit
                            </button>
                          </div>
                        )}

                        {/* 🟢 DEFAULT QR UI */}
                        {!isPending && !txMessage && (
                          <div className="nftmax-ptabs__separa">
                            <div className="nftmax-ptabs__form-main d-flex flex-column align-items-center">

                              <div className="nftmax__item-form--group w-100 text-center">
                                {/* QR Code */}
                                <div className="ai-qr-frame">
                                  {data?.address && (
                                    <QRCodeSVG
                                      value={data.address.toString()}
                                      size={180}
                                    />
                                  )}
                                  {!data?.address && <div style={{ width: 180, height: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#94a3b8' }}>Loading...</div>}
                                </div>

                                {/* Address Box */}
                                <div className="w-100">
                                  <div className="ai-address-box">
                                    <div className="ai-wallet-icon">
                                      <i className="fa fa-wallet"></i>
                                    </div>
                                    <div className="ai-address-text">
                                      {data?.address || "Loading Address..."}
                                    </div>
                                    <button className="ai-copy-btn" onClick={() => copyaddress(data?.address)}>
                                      <i className="fa fa-copy"></i>
                                    </button>
                                  </div>
                                </div>
                                {/* <p className="mt-3 text-secondary" style={{fontSize:12}}>Socket Status: <b style={{color: socket.connected ? '#10b981' : '#ef4444'}}>{socket.connected ? 'Live' : 'Connecting...'}</b></p> */}
                              </div>

                            </div>
                          </div>
                        )}

                      </div>
                    </div>

                    {/* Warning */}
                    <div className="ai-warning-box text-start w-100">
                      <i className="fa fa-exclamation-triangle mt-1 me-2"></i>
                      <div>
                        <strong>Important:</strong> Send only USDT (BEP20) to this deposit address. Sending any other coin may result in permanent loss.
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
